module.exports = __webpack_public_path__ + "static/media/Mitsubachi-7.d145b90e.jpg";